module.exports = __webpack_public_path__ + "frontend/images/homepage/carousel/desktop/0.png?bc8b5f76e3976e1b4b71a06f3af7c7b6";